import SurveyCreateLoader from '../SurveyCreate/parts/SurveyCreateLoader';
import SurveyDraftEdit from './parts/SurveyDraftEdit';
import { useParams } from 'react-router-dom';
import SurveyPublishedEdit from './parts/SurveyPublishedEdit';

function SurveyEdit() {
  const { draftId } = useParams<{ draftId: string }>();
  const isDraft = draftId !== undefined;

  if (isDraft) {
    return (
      <SurveyCreateLoader>
        <SurveyDraftEdit />
      </SurveyCreateLoader>
    );
  }

  return (
    <SurveyCreateLoader>
      <SurveyPublishedEdit />
    </SurveyCreateLoader>
  );
}

export default SurveyEdit;
